import React, { Suspense } from 'react'
import { Box, Container } from '@material-ui/core'
import { NotFoundView } from './views/NotFoundView'
import { HelmetTemplate } from 'components/templates/HelmetTemplate'
import { useLayout } from 'hooks/useLayout'
import { useStyles } from './Layout.styles'
import { useNotification } from 'store/notification/hook/useNotification'
import { useHelmet } from 'shared/hooks/useHelmet'
import Header from './ui/Navigation/Header/Header'
import Footer from './ui/Navigation/Footer/Footer'

const Layout = () => {
  useNotification()

  const classes = useStyles()
  const { routeResult, isLargeScreen, menuProps, isLibraryRoutesLoaded, footerItems, url, language } = useLayout()
  const { title, description, image } = useHelmet(url)
  const isNotTributeView = !window.location.pathname.match('hommage-nicolasjae')

  return (
    <>
      <HelmetTemplate title={title} description={description} image={image} url={url} language={language} />
      {isNotTributeView && <Header isLargeScreen={isLargeScreen} menuProps={menuProps} />}
      <Box className={isNotTributeView ? classes.marginLayout : ''}>
        <Box className={classes.content} displayPrint="block">
          <Container maxWidth="lg" component="main" style={{ flexGrow: 1 }}>
            <Box marginBottom={'2rem'}>
              {isLibraryRoutesLoaded &&
                (routeResult ? (
                  <Suspense fallback={<div></div>}>{routeResult}</Suspense> || <NotFoundView />
                ) : (
                  <NotFoundView />
                ))}
            </Box>
          </Container>
          {isNotTributeView && <Footer footerItems={footerItems} />}
        </Box>
      </Box>
    </>
  )
}

export default Layout
